<div class="p-10">
    <form nz-form nz-row [formGroup]="adjustVoidTimesheetForm" class="ppl-p0 mt-2">
        @if(!isAuthFail) {
        <div class="table-scroll-wrapper">
        <table class="timesheet-adjust-table"
            [class.wide-layout]="actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet'">
            <thead>
                <tr>
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 5%;"></th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 10%;">Service<br>Date <span class="required-marker">*</span></th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType ===
                    'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 9%;">Service<br>Code <span class="required-marker">*</span></th>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <th style="background-color: #a8e4e14d; width: 12%;">Service<br>Description <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 9%;">PPL Authorization<br>Number</th>
                    <th style="background-color: #a8e4e14d; width: 9%;">Regional<br>Center</th>
                    <th style="background-color: #a8e4e14d; width: 9%;">Clock In<br>Location <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 8%;">Time<br>In <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 9%;">Clock Out<br>Location <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 8%;">Time<br>Out <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 6%;">Total<br>Hours</th>
                    }
                    @if (source == 'billing' && actionType == 'adjustAllBillings') {
                    <th style="background-color: #a8e4e14d; width: 12%;">Regional<br>Center <span class="required-marker">*</span></th>
                    }
                    <th style="background-color: #a8e4e14d; width: 12%; white-space: pre-line;">{{this.reasonText}} <span class="required-marker">*</span></th>
                    <th style="background-color: #a8e4e14d; width: 12%;">Reason<br>Details @if(adjustVoidTimesheetForm.get('reason')?.value?.lkpValueName?.toLowerCase()?.startsWith('other')) {<span class="required-marker">*</span>}</th>
                    @if(source === 'payroll' && (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'voidTimesheet' || actionType === 'voidAllTimesheets')) {
                    <th style="background-color: #a8e4e14d; width: 12%;">CRM<br>Number <span class="required-marker">*</span></th>
                    }
                </tr>
            </thead>
            <tbody>
                <!-- Row 1: Input fields -->
                <tr>
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td><b>New values</b></td>
                    <td>
                        <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
                            [nzFormat]="'MM/dd/yyyy'" nzAllowClear="false"
                            [nzStatus]="adjustVoidTimesheetForm.get('serviceDate')?.invalid && adjustVoidTimesheetForm.get('serviceDate')?.touched ? 'error' : ''"></nz-date-picker>
                    </td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'resurrectTimesheet') {
                    <td>
                        <nz-select formControlName="serviceCode" class="filters" id="serviceCode"
                            nzPlaceHolder="Service Code" nzShowSearch
                            [compareWith]="compareServiceCode"
                            (ngModelChange)="onServiceCodeChange($event)"
                            [nzStatus]="adjustVoidTimesheetForm.get('serviceCode')?.invalid && adjustVoidTimesheetForm.get('serviceCode')?.touched ? 'error' : ''">
                            @for(opt of serviceCodes; track $index){
                            <nz-option [nzLabel]="opt.lkpValueName" [nzValue]="opt"></nz-option>
                            }
                        </nz-select>
                    </td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td>
                        <nz-select formControlName="serviceDescription" class="filters" id="serviceDescription"
                            nzPlaceHolder="Service Description" nzShowSearch nzAllowClear
                            (ngModelChange)="onServiceDescriptionChange($event)"
                            [nzStatus]="adjustVoidTimesheetForm.get('serviceDescription')?.invalid && adjustVoidTimesheetForm.get('serviceDescription')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of serviceDescriptions" [nzLabel]="opt.desc" [nzValue]="opt.ids"></nz-option>
                        </nz-select>
                    </td>
                    <td>
                        <span class="previous-value" id="pplAuthNum">{{ selectedPplAuthNum }}</span>
                    </td>
                    <td>
                        <span class="previous-value" id="regionalCenter">{{ selectedRegionalCenter }}</span>
                    </td>
                    <td>
                        <nz-select formControlName="clockInLoc" class="filters" id="clockInLoc"
                            nzPlaceHolder="Clock In Location" nzShowSearch nzAllowClear
                            [nzStatus]="adjustVoidTimesheetForm.get('clockInLoc')?.invalid && adjustVoidTimesheetForm.get('clockInLoc')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
                        </nz-select>
                    </td>
                    <td>
                        <p-datePicker formControlName="timeIn" [timeOnly]="true" [hourFormat]="'12'"
                            placeholder="HH:MM AM/PM"
                            [ngClass]="{ 'error-border': adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError'] }">
                        </p-datePicker>
                    </td>
                    <td>
                        <nz-select formControlName="clockOutLoc" class="filters" id="clockOutLoc"
                            nzPlaceHolder="Clock Out Location" nzShowSearch nzAllowClear
                            [nzStatus]="adjustVoidTimesheetForm.get('clockOutLoc')?.invalid && adjustVoidTimesheetForm.get('clockOutLoc')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of serviceLocations" [nzLabel]="opt.lkpValueName" [nzValue]="opt.lkpValueName"></nz-option>
                        </nz-select>
                    </td>
                    <td>
                        <p-datePicker formControlName="timeOut" [timeOnly]="true" [hourFormat]="'12'"
                            placeholder="HH:MM AM/PM"
                            [ngClass]="{ 'error-border': adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError'] }">
                        </p-datePicker>
                    </td>
                    <td>
                        <input nz-input formControlName="totalTime" id="totalTime" style="font-weight: bold;" />
                    </td>
                    }
                    @if(source == 'billing' && actionType == 'adjustAllBillings') {
                    <td>
                        <nz-select formControlName="mcoName" class="filters" id="mcoName" nzPlaceHolder="MCO"
                            nzShowSearch nzAllowClear
                            [nzStatus]="adjustVoidTimesheetForm.get('mcoName')?.invalid && adjustVoidTimesheetForm.get('mcoName')?.touched ? 'error' : ''">
                            @for(opt of mcoList; track $index){
                            <nz-option [nzLabel]="opt.orgName" [nzValue]="opt.orgName"></nz-option>
                            }
                        </nz-select>
                    </td>
                    }
                    <td>
                        <nz-select formControlName="reason" class="filters" id="reason" nzPlaceHolder="Select Reason"
                            nzShowSearch nzAllowClear
                            [nzStatus]="adjustVoidTimesheetForm.get('reason')?.invalid && adjustVoidTimesheetForm.get('reason')?.touched ? 'error' : ''">
                            <nz-option *ngFor="let opt of reasonList" [nzLabel]="opt.lkpValueName" [nzValue]="opt"></nz-option>
                        </nz-select>
                    </td>
                    <td>
                        <input nz-input formControlName="reasonDetails" placeholder="Enter reason details"
                            maxlength="160"
                            [class.ant-input-status-error]="adjustVoidTimesheetForm.get('reasonDetails')?.invalid && adjustVoidTimesheetForm.get('reasonDetails')?.touched" />
                    </td>
                    @if(source === 'payroll' && (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'voidTimesheet' || actionType === 'voidAllTimesheets')) {
                    <td>
                        <input nz-input formControlName="crmNumber" placeholder="Enter CRM Number"
                            maxlength="50"
                            [class.ant-input-status-error]="adjustVoidTimesheetForm.get('crmNumber')?.invalid && adjustVoidTimesheetForm.get('crmNumber')?.touched" />
                    </td>
                    }
                </tr>
                <!-- Row 2: Error messages -->
                <tr>
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td></td>
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('serviceDate')?.invalid && adjustVoidTimesheetForm.get('serviceDate')?.touched) {Please select the service date}</div></td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'resurrectTimesheet') {
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('serviceCode')?.invalid && adjustVoidTimesheetForm.get('serviceCode')?.touched) {Please select the service code}</div></td>
                    }
                    @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('serviceDescription')?.invalid && adjustVoidTimesheetForm.get('serviceDescription')?.touched) {Please select the service description}</div></td>
                    <td></td>
                    <td></td>
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('clockInLoc')?.invalid && adjustVoidTimesheetForm.get('clockInLoc')?.touched) {Please select the clock in location}</div></td>
                    <td>
                        <div class="error-message">
                            @if(adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError']) {
                                {{adjustVoidTimesheetForm.get('timeIn')?.errors?.['customError']}}
                            } @else if(adjustVoidTimesheetForm.get('timeIn')?.errors?.['required'] && adjustVoidTimesheetForm.get('timeIn')?.touched) {
                                Please enter the time in
                            }
                        </div>
                    </td>
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('clockOutLoc')?.invalid && adjustVoidTimesheetForm.get('clockOutLoc')?.touched) {Please select the clock out location}</div></td>
                    <td>
                        <div class="error-message">
                            @if(adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError']) {
                                {{adjustVoidTimesheetForm.get('timeOut')?.errors?.['customError']}}
                            } @else if(adjustVoidTimesheetForm.get('timeOut')?.errors?.['required'] && adjustVoidTimesheetForm.get('timeOut')?.touched) {
                                Please enter the time out
                            }
                        </div>
                    </td>
                    <td></td>
                    }
                    @if(source == 'billing' && actionType == 'adjustAllBillings') {
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('mcoName')?.invalid && adjustVoidTimesheetForm.get('mcoName')?.touched) {Please select the MCO}</div></td>
                    }
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('reason')?.invalid && adjustVoidTimesheetForm.get('reason')?.touched) {Please select the reason}</div></td>
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('reasonDetails')?.invalid && adjustVoidTimesheetForm.get('reasonDetails')?.touched) {Please enter the reason details}</div></td>
                    @if(source === 'payroll' && (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'voidTimesheet' || actionType === 'voidAllTimesheets')) {
                    <td><div class="error-message">@if(adjustVoidTimesheetForm.get('crmNumber')?.invalid && adjustVoidTimesheetForm.get('crmNumber')?.touched) {Please enter the CRM Number}</div></td>
                    }
                </tr>
                <!-- Row 3: Previous values -->
                @if(actionType === 'adjustTimesheet' || actionType === 'resurrectTimesheet') {
                <tr>
                    <td><b>Previous values</b></td>
                    <td><span class="previous-value">{{timesheetData?.serviceDate}}</span></td>
                    <td><span class="previous-value">{{timesheetData?.serviceCode?.lkpValueName}}</span></td>
                    <td><span class="previous-value">{{timesheetData?.authDesc}}</span></td>
                    <td></td>
                    <td></td>
                    <td><span class="previous-value">{{ isOvertimeEntry ? '-' : resolveLocationName(timesheetData?.clockInLoc) }}</span></td>
                    <td><span class="previous-value">{{ isOvertimeEntry ? '-' : timesheetData?.timeIn }}</span></td>
                    <td><span class="previous-value">{{ isOvertimeEntry ? '-' : resolveLocationName(timesheetData?.clockOutLoc) }}</span></td>
                    <td><span class="previous-value">{{ isOvertimeEntry ? '-' : timesheetData?.timeOut }}</span></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    @if(source === 'payroll' && (actionType === 'adjustTimesheet' || actionType === 'adjustAllTimesheet' || actionType === 'voidTimesheet' || actionType === 'voidAllTimesheets')) {
                    <td><span class="previous-value">{{timesheetData?.crmNumber}}</span></td>
                    }
                </tr>
                }
            </tbody>
        </table>
        </div>
        <div *ngIf="this.actionType === 'adjustAllTimesheet' ||
        this.actionType === 'voidAllTimesheets' ||
        this.actionType === 'voidAllBillings' ||
        this.actionType === 'adjustAllBillings' ||
        this.actionType === 'resurrectAllTimesheet'" class="alert alert-warning">
            <strong>{{this.message}}</strong>
        </div>
        @if(hasTimesheetAdjustError) {
            <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
                <span>{{timesheetAdjustErrorMessage}}</span>
            </div>
        }
        <div class="custom-row w-100 save-row">
            <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label={{buttonLabel}} icon="fa fa-check-circle"
                [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
        </div>
        }
        @else if(isAuthFail) {
            <div class="w-100 alert alert-danger d-flex justify-content-between align-items-center">
                <span>{{insufficientAuthMessage}}</span>
            </div>
        }
    </form>
</div>
